import React, { useEffect, useRef, useState } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import { useAppSelector } from '../../store/store';
import moment from 'moment';

const TradingViewChart: React.FC = () => {
    const { environmentRiskScoreChartData: chartData, currentScore } = useAppSelector(store => store?.mainDashboard.environmentRiskScore)
    const [options, setOptions] = useState<Highcharts.Options>({
        chart: {
            type: 'candlestick',
            // backgroundColor: '#0a0a0a'
        },
        title: {
            // text: 'Stock Price (Candlestick Chart)',
        },
        rangeSelector: {
            enabled: false
        },
        navigator: {
            enabled: false
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: false,
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                }
            },
            candlestick: {
                color: '#51a958',
                upColor: '#ea3d3d',
                upLineColor: '#ea3d3d',
                lineColor: '#51a958'
            }
        },
        series: [],
        xAxis: {
            // tickAmount: 6,
            gridLineWidth: 0,
            crosshair: {
                snap: false
            }
        },
        yAxis: [{
            gridLineWidth: 0,
            labels: {
                style: {
                    color: '#9d9da2'
                }
            },
            height: '70%',
            crosshair: {
                snap: false
            },
            accessibility: {
                description: 'price'
            }
        }, {
            gridLineWidth: 0,
            labels: {
                style: {
                    color: '#9d9da2'
                }
            },
            top: '70%',
            height: '30%',
            accessibility: {
                description: 'category'
            }
        }],
        tooltip: {
            shared: true,
            split: false,
            useHTML: true,
            shadow: false,
            positioner: function () {
                return { x: 50, y: 10 };
            }
        },
        scrollbar: {
            barBackgroundColor: '#464646',
            barBorderRadius: 0,
            barBorderWidth: 0,
            buttonBorderWidth: 0,
            buttonArrowColor: '#cccccc',
            rifleColor: '#cccccc',
            trackBackgroundColor: '#121211',
            trackBorderRadius: 0,
            trackBorderWidth: 1,
            trackBorderColor: '#464646'
        },
        exporting: {
            buttons: {
                contextButton: {
                    theme: {
                        fill: '#121211'
                    }
                }
            }
        },
        noData: {
            // text: 'No Data Available',
            // align: 'center',
            // verticalAlign: 'middle',
            style: {
                color: '#666', // Text color
                fontSize: '14px', // Font size
            },
        },
    });
    const { userData } = useAppSelector(store => store?.authReducer);
    useEffect(() => {
        if (userData)
            fetchData();
    }, [JSON.stringify(chartData), JSON.stringify(userData), currentScore]);
    const fetchData = async () => {
        const data = JSON.parse(JSON.stringify(chartData));
        // const data = await fetch(
        //     'https://demo-live-data.highcharts.com/aapl-ohlcv.json'
        // ).then(response => response.json());
        const ohlc: any[] = [],
            volume: any[] = [],
            dataLength = data.length;

        let previousCandleClose = +(currentScore || 0);
        // let previousCandleClose = 0;
        for (let i = 0; i < dataLength; i++) {
            if (data?.[i]?.recalculateScore) {
                if (previousCandleClose <= 70) {
                    if (parseFloat(data?.[i]?.change || "0") > 0) {
                        data[i].change = "0.5";
                    } else {
                        data[i].change = "-0.5";
                    }

                } else if (previousCandleClose > 70) {
                    if (parseFloat(data?.[i]?.change || "0") > 0) {
                        data[i].change = "0.25";
                    } else {
                        data[i].change = "-0.25";
                    }
                }
            }

            const currentChange = clampNumber(+previousCandleClose + parseFloat(data?.[i]?.change || "0"));
            const time = convertDateToLocalTime(parseInt(data[i].timestamp), userData?.timezone)
            ohlc.push([
                time, // the date
                (previousCandleClose), // open
                (currentChange), // high
                (previousCandleClose), // low
                (currentChange) // close
                // data[i][0], // the date
                // data[i][1], // open
                // data[i][2], // high
                // data[i][3], // low
                // data[i][4] // close
            ]);
            volume.push({
                x: time, // the date
                y: currentChange, // the volume
                color: currentChange > previousCandleClose ? '#a23f43' : '#466742',
                labelColor: currentChange > previousCandleClose ? '#a23f43' : '#466742'
                //     x: data[i][0], // the date
                //     y: data[i][5], // the volume
                //     color: data[i][4] > previousCandleClose ? '#466742' : '#a23f43',
                //     labelColor: data[i][4] > previousCandleClose ? '#51a958' : '#ea3d3d'
            });

            // console.log("ohlc ", ohlc, volume);
            previousCandleClose = currentChange;

            // previousCandleClose = data[i][4];
        }

        setOptions((prev) => {
            return {
                ...prev,
                time: {
                    timezone: userData?.timezone
                },
                series: [
                    {
                        type: 'candlestick',
                        id: 'ERS',
                        name: 'Environment Rick Score',
                        data: ohlc,
                        dataGrouping: {
                            enabled: true,
                            approximation: "ohlc"
                        },
                        tooltip: {
                            valueDecimals: 2,
                            pointFormat:
                                '<b>Open Score</b> <span style="color: {point.color}">' +
                                '{point.open} </span>' +
                                // '<b>H</b> <span style="color: {point.color}">' +
                                // '{point.high}</span><br/>' +
                                // '<b>L</b> <span style="color: {point.color}">{point.low} ' +
                                // '</span>' +
                                '<b>Close Score</b> <span style="color: {point.color}">' +
                                '{point.close}</span><br/>'
                        }
                    }, {
                        type: 'column',
                        name: 'Volume',
                        data: volume,
                        yAxis: 1,
                        borderRadius: 0,
                        groupPadding: 0,
                        pointPadding: 0,
                        dataGrouping: {
                            // enabled: false,
                            approximation: "average"
                        },
                        tooltip: {
                            pointFormat: '<b>Score</b> <span style="color: ' +
                                '{point.labelColor}">{point.y}</span><br/>'
                        }
                    },
                ]
            }
        })
    }
    return (
        <>
            {chartData?.length === 0 ?
                <p style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "70%", fontSize: "large", fontWeight: "bolder" }}>No data available.</p> :
                <HighchartsReact highcharts={Highcharts} constructorType={'stockChart'} options={options} />}
        </>
    );
};

export default TradingViewChart;

const convertDateToLocalTime = (time: number, timeZone: string) => {
    let date = moment.utc(time);
    if (timeZone) {
        date = date.tz(timeZone);
    } else {
        date = date.local();
    }

    return date.valueOf();
}

function clampNumber(num: number): number {
    if (num < 0) return 0;
    if (num > 100) return 100;
    return num;
}


